import type { Tag } from "@/services/tags.service";

// Which tags a stash list's tag row offers (native StashTagFilter, LibraryView.swift).

export type TagScope = "all" | "mine" | "suggested";

export const TAG_SCOPES: TagScope[] = ["all", "mine", "suggested"];
export const TAG_SCOPE_LABELS: Record<TagScope, string> = { all: "All tags", mine: "My Tags", suggested: "Suggested Tags" };

export type ScopedTag = Pick<Tag, "state" | "source">;

/** A tag the system suggested and nobody confirmed (native `initialMode == .suggested`). */
export const isSuggestedTag = (tag: ScopedTag) => tag.state === "suggested" || (tag.state == null && tag.source === "auto");

export const tagInScope = (tag: ScopedTag, scope: TagScope) =>
  scope === "all" || (scope === "suggested") === isSuggestedTag(tag);

export const availableTagScopes = (tags: ScopedTag[]) => TAG_SCOPES.filter(scope => tags.some(tag => tagInScope(tag, scope)));

/** The scope the row shows: a choice with no tags gives way to one that has them, suggestions first. */
export function shownTagScope(scope: TagScope, tags: ScopedTag[]): TagScope {
  const choices = availableTagScopes(tags);
  if (choices.includes(scope)) return scope;
  return choices.includes("suggested") ? "suggested" : choices.includes("mine") ? "mine" : "all";
}
